// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".advanced-list-cell-text-wrap{max-width:inherit;max-height:4.5em;line-height:1.5em;white-space:normal;overflow-wrap:break-word;word-break:break-word;overflow-y:auto;overflow-x:hidden;padding-right:4px}", ""]);
// Exports
module.exports = exports;
